<template>
    <transition name="slide-fade" >

        <div  id="academicsHolder" style="min-height: 90vh !important;">
            <div class="uk-child-width-1-1" uk-grid>
                <div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
                    <div class="uk-container uk-container-small ">
                        <p class="uk-text-center uk-text-lead@l uk-text-large@l">
                            Choose from our 60+ Undergraduate degrees programmes the path in which you wish to grow with us.

                        </p>
                    </div>
                </div>
                <div>
                    <div class="uk-container uk-container-large uk-margin-small">
                        <div >
                            <div class="uk-child-width-1-2@m" uk-grid>
                                <div>
                                    <form class="uk-search uk-search-large">
                                        <span uk-search-icon></span>
                                        <input class="uk-search-input " type="search" placeholder="Search..." v-model="searchDegree" style="width: 100%">
                                    </form>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

                <div class="uk-background-muted  uk-margin-remove-top uk-padding ">
                    <div class="uk-container uk-container-large" v-if="gridView === true">

                        <div class="uk-child-width-1-1 uk-child-width-1-3@m uk-child-width-1-4@l " uk-grid>
                            <div v-for="item in filterDegree" >
                                <div class="uk-card uk-card-default" style="border-radius: 15px;">
                                    <div class="uk-card-media-top">
                                        <!--<img :src="'http://cmsapi.ncu.edu.jm/' + item.thumbnailImage" class="uk-responsive-height uk-responsive-width" alt=""
                                             style="max-width: 300px; max-height: 300px; height: auto; width: auto; border-top-left-radius: 15px; border-top-right-radius: 15px; ">-->
                                    </div>
                                   f
                                </div>
                            </div>
                        </div>

                    </div>


                </div>







            </div>

        </div>
    </transition>
</template>

<script>
    export default {
        name: "undergradprograms",
        data(){
            return {
                image: location.origin + '/static/logo.png',
                imgHide: true,
                tableView: false,
                gridView: true,
                searchDegree: ''
            }
        },
        methods: {
            findDegree: function(event){
                //this.$store.commit('getArticle', (event.target.id))
                //console.log(event.target)
                this.$router.push({ path: '/undergrad', query: { degreeName: event.target.id, degreeType: 'u_programs' }})
            },
            findNewDegree: function(event){
                //this.$store.commit('getArticle', (event.target.id))
                //console.log(event.target)
                this.$router.push({ path: '/undergrad', query: { degree: event.target.id }})
            },
            switchToGrid: function(){
                this.tableView = false
                this.gridView = true
            },
            switchToTable: function(){
                this.tableView = true
                this.gridView = false
            },
        },
        computed: {
            loadDegrees: function () {
                //this.pageLoad = true
                //console.log(this.$store.state.undergradDegrees.associate_degree)
                return this.$store.state.degree.undergradDegrees
            },
            loadNewDegrees: function () {
                //this.pageLoad = true
                //console.log(this.$store.state.undergradDegrees.associate_degree)
                return this.$store.state.undergradDegrees
            },
            filterDegree: function(){
                const searchTerm = new RegExp(this.searchDegree, 'i');
                //const searchEvent = new RegExp(this.search_by_event_type, 'i');

                /* this.model.filter((item) =>
                   searchTerm.test(item.clients_association) &&
                   searchEvent.test(item.event_type)
                 );*/
                return this.loadNewDegrees.filter((degree) =>{
                    return degree.degreeName.match(searchTerm)
                })
            }
        },
        mounted(){
            this.$store.dispatch('getUndergraduateDegrees')
            window.scrollTo(0, 0);
        },
        beforeCreate(){
            this.$store.dispatch('degree/AllUndergradDegrees')

        },
        updated(){
            this.imgHide = false
        },
        metaInfo: {
            // Children can override the title.
            title: 'NCU Undergraduate Degrees',
            // Result: My Page Title ← My Site
            // If a child changes the title to "My Other Page Title",
            // it will become: My Other Page Title ← My Site
            //titleTemplate: '%s ← My Site',
            // Define meta tags here.
            meta: [
                {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
                {name: 'viewport', content: 'width=device-width, initial-scale=1'},
                {name: 'description', content: 'Undergraduate Degrees offered by Northern Caribbean University '}
            ]
        }
    }
</script>

<style scoped>
    #academicsHolder{
        min-height: 75vh;
    }
    .colorIt{
        color: #333 !important;
    }
    .borderIt{
        border: #333 solid 1px !important;
    }
    .bgIt{
        background-color: #333 !important;
    }
    .whiteIt{
        color: white !important;
    }
    .smallSize{
        font-size: 10pt !important;
        padding-left: 15px;
    }
    h4, h5{
        color: silver !important;
    }
    tr > td{
        border: 1px solid #EEEEEE;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 15px;
        padding-right: 15px;
    }
</style>
